<template>
  <v-container fluid fill-height class="bgimage">
    <v-layout column align-center justify-center>
      <v-flex xs8 sm4 md4>
        <v-card dark class="formi">
          <v-toolbar>
            <v-toolbar-title>
              Select project
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              @submit="watchProject"
              @submit.prevent
            >
              <v-text-field
                v-model="projectId"
                label="Project ID"
                browser-autocomplete="new-password"
              ></v-text-field>
              <v-text-field
                :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                :type="show ? 'text' : 'password'"
                label="Site Password"
                v-model="passwordi"
                browser-autocomplete="new-password"
                @click:append="show = !show"
              ></v-text-field>
              <v-layout column align-center justify-center>
                <v-btn
                  type="submit"
                  color="blue"
                  light
                  :disabled="!projectId"
                >
                  Watch
                </v-btn>
              </v-layout>
            </v-form>
            <div class="error-text" v-if="error">
              {{ error }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import { Logger } from 'aws-amplify';
// const logger = new Logger('Home');

export default {
  props: {
    project: {
      type: String,
      required: false,
    },
    hint: {
      type: String,
      required: false,
    },

  },
  data() {
    return {
      projectId: this.project,
      show: false,
      passwordi: '',
      error: this.hint,
    };
  },
  methods: {
    watchProject() {
      this.$store.commit('sitePassword', this.passwordi);

      this.$projects.get(this.projectId)
        .then(() => {
          // Project and hotspots fetched, so redirect to reader
          this.$router.push({ name: 'player', params: { id: this.projectId } });
        })
        .catch((err) => {
          this.setError(err);
        });
    },
    setError(err) {
      this.error = err.error;
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
}
.formi {
  opacity: 0.9;
}
</style>
